import { createSelector } from 'reselect';
import { initialState } from './reducer';

/**
 * Direct selector to the adjustments state domain
 */

const selectAdjustmentsDomain = state => state.adjustments || initialState;

/**
 * Other specific selectors
 */

/**
 * Default selector used by Adjustments
 */

const makeSelectAdjustments = () =>
  createSelector(
    selectAdjustmentsDomain,
    substate => substate,
  );

export default makeSelectAdjustments;
export { selectAdjustmentsDomain };
